import Vue from 'vue';
import { Component, Inject, Emit } from 'vue-property-decorator';

@Component
export default class ProjectOverviewHeader extends Vue {
}
